import retrieveCart from './retrieveCart';
import Gift from '../loyalty/gift';

const updateAddingToCartButtons = (formEl) => {
  const availableEl = formEl.querySelector('button[name="add"] [data-add-to-cart-available]');
  if (availableEl) {
    availableEl.textContent = window.theme.strings.addingToCart;
  }

  const availableQVEl = formEl.querySelector('button[name="add"] [data-quickview-add-to-cart-available]');
  if (availableQVEl) {
    availableQVEl.textContent = window.theme.strings.addingToCart;
  }

  const desktopStickyEl = document.querySelector('[data-desktop-sticky-add-to-cart-main] [data-add-to-cart-available]');
  if (desktopStickyEl) {
    desktopStickyEl.textContent = window.theme.strings.addingToCart;
  }

  const mobileStickyEl = document.querySelector('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]');
  if (mobileStickyEl) {
    mobileStickyEl.textContent = window.theme.strings.addingToCart;
  }
};

export default ($form, redirect = '') => {
  return new Promise((resolve, reject) => {
    document.querySelectorAll('[data-add-to-cart-error]').forEach(el => el.classList.remove('active'));
    const edit_mode = document.body.classList.contains('edit-cart');

    let add_data = $form;
    if (typeof $form !== 'string') {
      // If $form is a jQuery object, get the DOM element
      const formEl = $form instanceof HTMLElement ? $form : $form[0];
      add_data = new URLSearchParams(new FormData(formEl)).toString();

      updateAddingToCartButtons(formEl);
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
      body: add_data,
    })
    .then(async response => {
      if (!response.ok) {
        const XHR = await response.json();
        if (typeof XHR.description !== 'undefined') {
          document.querySelectorAll('[data-add-to-cart-error]').forEach(el => {
            el.innerHTML = XHR.description;
            el.classList.add('active');
          });
        }
        resolve(false);
        return;
      }

      return response.json();
    }).then(async data => { // Data is just the added item, not the entire cart
      if (window.theme.cart.drawerInstance !== null) {
        window.theme.cart.drawerInstance.setAddedItem(data);
      }
      
      window.theme.cart.data = await retrieveCart();

      if (redirect.length) {
        window.location.href = redirect;
        resolve(true);
        return;
      }

      if (edit_mode) {
        window.location.reload(false);
        resolve(true);
        return;
      }

      new Gift();

      // Desktop - quicklook-modal can be on any page (search overlay)
      const quicklookModal = document.getElementById('quicklook-modal');
      if (quicklookModal && quicklookModal.classList.contains('is-open')) {
        const availableEl = quicklookModal.querySelector('[data-quickview-add-to-cart-available]');
        if (availableEl) {
          availableEl.textContent = window.theme.strings.addedToCart;
          window.setTimeout(() => {
            availableEl.textContent = window.theme.strings.addToCart;
          }, 800);
        }

        window.setTimeout(() => {
          window.theme.cart.drawerInstance.updateDrawer(null, true);

          // Don't close the modal to avoid a blinking effect with the overlay
          // quicklookModal.querySelector('.modal__close').click();
        }, (window.theme.cart.drawerInstance.getDrawerType() === 'cart') ? 1000 : 1);

        resolve(true);
        return;
      }

      // Mobile - quicklook-modal-mobile can be on any page (search overlay)
      const quicklookModalMobile = document.getElementById('quicklook-modal-mobile');
      if (quicklookModalMobile && quicklookModalMobile.classList.contains('active')) {
        const availableEl = quicklookModalMobile.querySelector('[data-quickview-add-to-cart-available]');
        if (availableEl) {
          availableEl.textContent = window.theme.strings.addedToCart;
          window.setTimeout(() => {
            availableEl.textContent = window.theme.strings.addToCart;
          }, 800);
        }

        window.setTimeout(() => {
          window.theme.cart.drawerInstance.updateDrawer(null, true);

          quicklookModalMobile.querySelector('.close-modal').click();
        }, (window.theme.cart.drawerInstance.getDrawerType() === 'cart') ? 1000 : 1);

        resolve(true);
        return;
      }

      // Delay slideout cart opening and CTA updates
      if (document.querySelector('.template-pdp') && !document.querySelector('[data-overlay-search]').classList.contains('opened')) {
        const overviewEl = document.querySelector('[data-product-overview] [data-add-to-cart-available]');
        const desktopStickyEl = document.querySelector('[data-desktop-sticky-add-to-cart-main] [data-add-to-cart-available]');
        const mobileStickyEl = document.querySelector('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]');

        if (overviewEl) overviewEl.textContent = window.theme.strings.addedToCart;
        if (desktopStickyEl) desktopStickyEl.textContent = window.theme.strings.addedToCart;
        if (mobileStickyEl) mobileStickyEl.textContent = window.theme.strings.addedToCart;

        window.setTimeout(() => {
          if (overviewEl) overviewEl.textContent = window.theme.strings.addToCart;
          if (desktopStickyEl) desktopStickyEl.textContent = window.theme.strings.addToCart;
          if (mobileStickyEl) mobileStickyEl.textContent = window.theme.strings.addToCart;
        }, 800);

        window.setTimeout(() => {
          window.theme.cart.drawerInstance.updateDrawer(null, true);
        }, 1000);

        resolve(true);
        return;
      }

      window.theme.cart.drawerInstance.updateDrawer(null, true);
      resolve(true);
    })
    .catch(error => {
      console.log(error);
      resolve(false);
    });
  });
};
